import React, { useState } from 'react'
import { useLocalStorageCountdown } from 'hooks'
import { isValidEmail } from 'utils'
import { Input } from 'components/Controls'
import { T } from 'components/Translations'
import Button from 'components/Button'

const RESEND_COUNTDOWN_SECONDS = +localStorage.resendCountdown || 5 * 60 // P_Welcome_Emails_Resend_Delay_Minutes

// TODO - merge Input[hasError] with the validation below
const EmailForm = ({ editable, onSubmit, initialEmail, initialEmailMsg }) => {
  const countdown = useLocalStorageCountdown('canResendEmailAt', RESEND_COUNTDOWN_SECONDS)
  const [ready, seconds, reset] = countdown
  const [email, setEmail] = useState(initialEmail)
  const [validEmail, setValidEmail] = useState(true)
  const onEmailChange = e => {
    if (!editable) return e.preventDefault()
    setEmail(e.target.value)
    setValidEmail(true)
  }

  const onEmailSubmit = e => {
    e.preventDefault()
    const valid = isValidEmail(email)
    setValidEmail(valid)
    if (valid) {
      reset()
      onSubmit({
        email,
        field: initialEmail == email ? 'initialEmailMsg' : 'newEmailMsg',
      })
    }
  }

  return (
    <form className="resend-email" onSubmit={onEmailSubmit}>
      <Input
        inline
        hasError
        className="current-email"
        value={email}
        onChange={onEmailChange}
        type="email"
        error={{ field: 'newEmailMsg', position: 'vertical' }}
      />

      {initialEmailMsg && <div className="form-msg">{initialEmailMsg}</div>}
      <T label="confirmation/notReceived" />

      <Button type="submit" color="cta" label="confirmation/resend" disabled={!ready} countdown={seconds} />
      {!validEmail && <T as="div" className="form-msg" label="enterValidEmail" />}
    </form>
  )
}

export default EmailForm
